module.exports = "/images/ne.svg?f919b867e433fd458f7d57e59a233931";